// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/trash-2.js';

import { paths } from '../generated/trash-2';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('trash-2', Original, paths);
